(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alfresco-hero"] && !Shopify.designMode) return;
  try {
    
  const heroes = document.querySelectorAll('[data-alfresco-hero]');

  heroes.forEach((hero) => {
    const slides = Array.from(hero.querySelectorAll('[data-alfresco-slide]'));
    const dots = Array.from(hero.querySelectorAll('[data-alfresco-dot]'));
    const cursor = hero.querySelector('[data-alfresco-cursor]');
    const speed = Number(hero.dataset.autoplaySpeed) || 5000;
    let activeIndex = 0;
    let timer;
    let cursorDirection = 'next';

    if (slides.length < 2) {
      return;
    }

    const setActiveSlide = (index) => {
      activeIndex = index;

      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === activeIndex);
      });

      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === activeIndex);
      });
    };

    const start = () => {
      window.clearInterval(timer);
      timer = window.setInterval(() => {
        setActiveSlide((activeIndex + 1) % slides.length);
      }, speed);
    };

    const previousSlide = () => {
      setActiveSlide((activeIndex - 1 + slides.length) % slides.length);
      start();
    };

    const nextSlide = () => {
      setActiveSlide((activeIndex + 1) % slides.length);
      start();
    };

    const updateCursor = (event) => {
      if (!cursor) {
        return;
      }

      const rect = hero.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      cursorDirection = x < rect.width / 2 ? 'prev' : 'next';

      cursor.style.setProperty('--cursor-x', `${x}px`);
      cursor.style.setProperty('--cursor-y', `${y}px`);
      cursor.classList.toggle('is-prev', cursorDirection === 'prev');
      cursor.classList.toggle('is-next', cursorDirection === 'next');
      cursor.classList.add('is-visible');
    };

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => {
        setActiveSlide(dotIndex);
        start();
      });
    });

    hero.addEventListener('pointermove', updateCursor);
    hero.addEventListener('pointerenter', updateCursor);
    hero.addEventListener('pointerleave', () => {
      if (cursor) {
        cursor.classList.remove('is-visible');
      }
      start();
    });
    hero.addEventListener('click', (event) => {
      if (event.target.closest('a, button')) {
        return;
      }

      if (cursorDirection === 'prev') {
        previousSlide();
      } else {
        nextSlide();
      }
    });
    hero.addEventListener('mouseenter', () => window.clearInterval(timer));
    hero.addEventListener('focusin', () => window.clearInterval(timer));
    hero.addEventListener('focusout', start);

    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      if (url.hash) {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      }

      const activeCollectionPill = document.querySelector('.nook-collection__tab--current');
      if (activeCollectionPill && window.matchMedia('(min-width: 750px)').matches) {
        activeCollectionPill.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    },
    { once: true }
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video-gallery"] && !Shopify.designMode) return;
  try {
    
  class ShoppableVideoGallery {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector('.svg-viewport');
      this.track = root.querySelector('.svg-track');
      this.slides = Array.from(root.querySelectorAll('[data-svg-slide]'));
      this.prevButton = root.querySelector('.svg-arrow--previous');
      this.nextButton = root.querySelector('.svg-arrow--next');
      this.pagination = root.querySelector('.svg-pagination');
      this.activeIndex = 0;
      this.visualActivePosition = 0;
      this.currentTrackX = 0;
      this.isIntersecting = true;
      this.raf = 0;
      this.destroyCallbacks = [];
      this.resizeObserver = null;
      this.intersectionObserver = null;
      this.pointer = null;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.loop = root.dataset.loop === 'true';
      this.clickInactive = root.dataset.clickInactive === 'true';
      this.swipe = root.dataset.swipe === 'true';
      this.autoplay = root.dataset.autoplay === 'true';
      this.videoLoop = root.dataset.videoLoop === 'true';
      this.startMuted = root.dataset.startMuted !== 'false';
      this.pauseOutside = root.dataset.pauseOutside !== 'false';
      this.threshold = Number(root.dataset.threshold || .35);
      this.initialIndex = Number(root.dataset.initialIndex || 0);
    }

    init() {
      if (!this.root || !this.viewport || !this.track || this.slides.length === 0) return;
      this.applyPosters();
      this.buildPagination();
      this.bind();
      this.setActive(this.initialIndex, false);
      this.root.shoppableVideoGalleryInstance = this;
    }

    bind() {
      this.on(this.prevButton, 'click', () => this.setActive(this.activeIndex - 1, true));
      this.on(this.nextButton, 'click', () => this.setActive(this.activeIndex + 1, true));
      this.slides.forEach((slide, index) => {
        this.on(slide, 'click', event => {
          if (!this.clickInactive || index === this.activeIndex) return;
          if (event.target.closest('a, button')) return;
          this.setActive(index, true);
        });
      });
      this.root.querySelectorAll('.svg-sound-button').forEach(button => {
        this.on(button, 'click', event => {
          event.preventDefault();
          event.stopPropagation();
          this.toggleSound(button);
        });
      });
      this.on(this.root, 'keydown', event => {
        if (event.key === 'ArrowLeft') {
          this.setActive(this.activeIndex - 1, true);
        }
        if (event.key === 'ArrowRight') {
          this.setActive(this.activeIndex + 1, true);
        }
      });
      if (this.swipe) {
        this.on(this.viewport, 'pointerdown', event => this.handlePointerDown(event));
        this.on(this.viewport, 'pointermove', event => this.handlePointerMove(event));
        this.on(this.viewport, 'pointerup', event => this.handlePointerUp(event));
        this.on(this.viewport, 'pointercancel', () => this.pointer = null);
      }
      this.resizeObserver = new ResizeObserver(() => this.scheduleCorrection());
      this.resizeObserver.observe(this.viewport);
      this.slides.forEach(slide => this.resizeObserver.observe(slide));
      this.intersectionObserver = new IntersectionObserver(entries => {
        this.isIntersecting = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= this.threshold);
        if (this.isIntersecting) {
          this.playActiveVideo();
        } else if (this.pauseOutside) {
          this.pauseAllVideos();
        }
      }, { threshold: [0, this.threshold, 1] });
      this.intersectionObserver.observe(this.root);
      this.on(window, 'resize', () => this.scheduleCorrection());
      this.on(window, 'orientationchange', () => this.scheduleCorrection());
      this.on(document, 'visibilitychange', () => {
        if (document.hidden) {
          this.pauseAllVideos();
        } else if (this.isIntersecting) {
          this.playActiveVideo();
        }
      });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.scheduleCorrection());
      }
      this.root.querySelectorAll('video').forEach(video => {
        this.on(video, 'loadeddata', () => this.playActiveVideo());
        this.on(video, 'canplay', () => this.playActiveVideo());
      });
    }

    on(target, eventName, handler) {
      if (!target) return;
      target.addEventListener(eventName, handler);
      this.destroyCallbacks.push(() => target.removeEventListener(eventName, handler));
    }

    buildPagination() {
      if (!this.pagination) return;
      this.pagination.innerHTML = '';
      this.slides.forEach((slide, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'svg-dot';
        dot.setAttribute('aria-label', `Go to video ${index + 1}`);
        dot.addEventListener('click', () => this.setActive(index, true));
        this.pagination.appendChild(dot);
      });
    }

    applyPosters() {
      this.slides.forEach(slide => {
        const poster = slide.querySelector('[data-poster]');
        const video = slide.querySelector('video');
        if (poster && video) video.poster = poster.dataset.poster;
      });
    }

    resolveIndex(index) {
      const max = this.slides.length - 1;
      if (this.loop) {
        if (index < 0) return max;
        if (index > max) return 0;
        return index;
      }
      return Math.max(0, Math.min(index, max));
    }

    setActive(index, animate = true) {
      if (!this.slides.length) return;
      const nextIndex = this.resolveIndex(index);
      this.activeIndex = nextIndex;
      this.updateSlideOrder(nextIndex);
      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === nextIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        slide.tabIndex = isActive ? 0 : -1;
      });
      this.pauseAllVideos();
      this.updatePagination();
      this.updateArrows();
      this.moveToActive(nextIndex, animate);
      this.playActiveVideo();
    }

    updateSlideOrder(activeIndex) {
      const slideCount = this.slides.length;
      if (!this.loop || slideCount < 3) {
        this.visualActivePosition = activeIndex;
        this.slides.forEach((slide, slideIndex) => {
          slide.style.order = slideIndex;
        });
        return;
      }

      const activeSlot = Math.floor(slideCount / 2);
      const rightSlots = slideCount - activeSlot - 1;
      this.visualActivePosition = activeSlot;

      this.slides.forEach((slide, slideIndex) => {
        const relativeIndex = (slideIndex - activeIndex + slideCount) % slideCount;
        const visualSlot = relativeIndex <= rightSlots
          ? activeSlot + relativeIndex
          : activeSlot + relativeIndex - slideCount;

        slide.style.order = visualSlot;
      });
    }

    updatePagination() {
      if (!this.pagination) return;
      Array.from(this.pagination.children).forEach((dot, index) => {
        if (index === this.activeIndex) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    updateArrows() {
      if (this.loop) return;
      if (this.prevButton) this.prevButton.disabled = this.activeIndex === 0;
      if (this.nextButton) this.nextButton.disabled = this.activeIndex === this.slides.length - 1;
    }

    getLength(name, basis) {
      const value = getComputedStyle(this.root).getPropertyValue(name).trim();
      if (value.endsWith('vw')) return window.innerWidth * Number(value.replace('vw', '')) / 100;
      if (value.endsWith('px')) return Number(value.replace('px', ''));
      if (value.startsWith('min(')) {
        const slide = this.slides[this.activeIndex];
        return slide ? slide.getBoundingClientRect().width : basis;
      }
      return Number.parseFloat(value) || basis || 0;
    }

    getGap() {
      const value = getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap;
      if (value.endsWith('px')) return Number(value.replace('px', ''));
      return Number.parseFloat(value) || 0;
    }

    getActiveWidth() {
      const activeSlide = this.slides[this.activeIndex];
      if (activeSlide) return activeSlide.getBoundingClientRect().width || this.getLength('--svg-active-width', 0);
      return this.getLength('--svg-active-width', 0);
    }

    getInactiveWidth() {
      const inactiveSlide = this.slides.find((slide, index) => index !== this.activeIndex);
      if (inactiveSlide) return inactiveSlide.getBoundingClientRect().width || this.getLength('--svg-inactive-width', 0);
      return this.getLength('--svg-inactive-width', 0);
    }

    calculateTargetX(index) {
      const viewportWidth = this.viewport.clientWidth;
      const activeWidth = this.getActiveWidth();
      const inactiveWidth = this.getInactiveWidth();
      const gap = this.getGap();
      const activeVisualIndex = this.loop ? this.visualActivePosition : index;
      const precedingWidth = activeVisualIndex * inactiveWidth + activeVisualIndex * gap;
      const activeCentre = precedingWidth + activeWidth / 2;
      return viewportWidth / 2 - activeCentre;
    }

    moveToActive(index, animate) {
      cancelAnimationFrame(this.raf);
      this.track.style.transition = animate && !this.reducedMotion ? '' : 'none';
      this.raf = requestAnimationFrame(() => {
        const targetX = this.calculateTargetX(index);
        this.currentTrackX = targetX;
        this.track.style.transform = `translate3d(${targetX}px, 0, 0)`;
        const afterMove = () => {
          this.correctMeasuredCentre();
          this.track.removeEventListener('transitionend', afterMove);
        };
        if (animate && !this.reducedMotion) {
          this.track.addEventListener('transitionend', afterMove);
        } else {
          requestAnimationFrame(() => this.correctMeasuredCentre());
        }
      });
    }

    correctMeasuredCentre() {
      const activeSlide = this.slides[this.activeIndex];
      if (!activeSlide) return;
      const viewportRect = this.viewport.getBoundingClientRect();
      const slideRect = activeSlide.getBoundingClientRect();
      const viewportCentre = viewportRect.left + viewportRect.width / 2;
      const slideCentre = slideRect.left + slideRect.width / 2;
      const difference = viewportCentre - slideCentre;
      if (Math.abs(difference) < .5) return;
      this.currentTrackX += difference;
      this.track.style.transition = 'none';
      this.track.style.transform = `translate3d(${this.currentTrackX}px, 0, 0)`;
      requestAnimationFrame(() => {
        this.track.style.transition = '';
      });
    }

    scheduleCorrection() {
      cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(() => {
        this.currentTrackX = this.calculateTargetX(this.activeIndex);
        this.track.style.transition = 'none';
        this.track.style.transform = `translate3d(${this.currentTrackX}px, 0, 0)`;
        this.correctMeasuredCentre();
      });
    }

    pauseAllVideos() {
      this.root.querySelectorAll('video').forEach(video => {
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.loop = this.videoLoop;
        video.pause();
        try {
          video.currentTime = 0;
        } catch (error) {
        }
      });
      this.root.querySelectorAll('.svg-sound-button').forEach(button => {
        button.classList.remove('is-unmuted');
        button.setAttribute('aria-label', 'Unmute video');
      });
    }

    playActiveVideo() {
      if (!this.autoplay || !this.isIntersecting && this.pauseOutside) return;
      const activeSlide = this.slides[this.activeIndex];
      if (!activeSlide) return;
      const video = activeSlide.querySelector('video');
      if (!video) return;
      video.defaultMuted = this.startMuted;
      video.muted = this.startMuted;
      video.playsInline = true;
      video.loop = this.videoLoop;
      video.play().catch(() => {});
    }

    toggleSound(button) {
      const activeSlide = this.slides[this.activeIndex];
      const video = activeSlide ? activeSlide.querySelector('video') : null;
      if (!video) return;
      video.muted = !video.muted;
      button.classList.toggle('is-unmuted', !video.muted);
      button.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
    }

    handlePointerDown(event) {
      this.pointer = { x: event.clientX, y: event.clientY, active: false };
    }

    handlePointerMove(event) {
      if (!this.pointer) return;
      const dx = event.clientX - this.pointer.x;
      const dy = event.clientY - this.pointer.y;
      if (Math.abs(dx) > Math.abs(dy) * 1.3) {
        this.pointer.active = true;
      }
    }

    handlePointerUp(event) {
      if (!this.pointer) return;
      const dx = event.clientX - this.pointer.x;
      const dy = event.clientY - this.pointer.y;
      const isHorizontal = Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3;
      if (this.pointer.active && isHorizontal) {
        this.setActive(dx < 0 ? this.activeIndex + 1 : this.activeIndex - 1, true);
      }
      this.pointer = null;
    }

    destroy() {
      cancelAnimationFrame(this.raf);
      this.destroyCallbacks.forEach(callback => callback());
      this.destroyCallbacks = [];
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.intersectionObserver) this.intersectionObserver.disconnect();
      this.pauseAllVideos();
      delete this.root.shoppableVideoGalleryInstance;
    }
  }

  function initShoppableVideoGallery(root) {
    if (!root) return;
    if (root.shoppableVideoGalleryInstance) root.shoppableVideoGalleryInstance.destroy();
    const instance = new ShoppableVideoGallery(root);
    instance.init();
  }

  function initAllShoppableVideoGalleries(scope = document) {
    scope.querySelectorAll('.svg-section[id^="svg-"]').forEach(root => initShoppableVideoGallery(root));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllShoppableVideoGalleries());
  } else {
    initAllShoppableVideoGalleries();
  }

  document.addEventListener('shopify:section:load', event => initAllShoppableVideoGalleries(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const root = event.target.querySelector('.svg-section[id^="svg-"]');
    if (root && root.shoppableVideoGalleryInstance) root.shoppableVideoGalleryInstance.destroy();
  });
  document.addEventListener('shopify:block:select', event => {
    const root = event.target.closest('.svg-section[id^="svg-"]');
    if (!root || !root.shoppableVideoGalleryInstance) return;
    const index = root.shoppableVideoGalleryInstance.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
    if (index >= 0) root.shoppableVideoGalleryInstance.setActive(index, false);
  });

  } catch(e) { console.error(e); }
})();
})();
